/**
 * Generated by orval v8.22.0 🍺
 * Do not edit manually.
 * PHRMPC.Manning.Web.API | v1
 * OpenAPI spec version: 1.0.0
 */
import { z as zod } from 'zod';
import { MemberBasicInfoDto } from './memberBasicInfoDto.schema';

export const IReadOnlyListOfMemberBasicInfoDto = zod.array(zod.lazy(() => MemberBasicInfoDto));

export type IReadOnlyListOfMemberBasicInfoDto = zod.input<typeof IReadOnlyListOfMemberBasicInfoDto>;
export type IReadOnlyListOfMemberBasicInfoDtoOutput = zod.output<typeof IReadOnlyListOfMemberBasicInfoDto>;
